import { SkeletonLoader, Stack } from "@bookingcom/bui-react";
import * as React from "react";
export function SkeletonListKeyValue({ amount = 3 }) {
    const items = [];
    for (let i = 0; i < amount; i++) {
        items.push(React.createElement(Stack, { key: i, direction: "row", justifyContent: "space-between", gap: 8 },
            React.createElement(SkeletonLoader, { width: "calc(80% - 72px)" }),
            React.createElement(SkeletonLoader, { width: "48px" })));
    }
    return React.createElement(Stack, { gap: 4 }, items);
}
